import { render, staticRenderFns } from "./DedicationSales.vue?vue&type=template&id=0cf122f6&scoped=true&"
import script from "./DedicationSales.vue?vue&type=script&lang=js&"
export * from "./DedicationSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf122f6",
  null
  
)

export default component.exports